(function (pregnancyLeave, $) {

    /* Initialize handlers for compensation changes */
    pregnancyLeave.InitApplyCompensationChangedHandler = function () {
        var gridSelector = '[data-absencesettingsgrid]';

        $('#ApplyCompensationTrue').change(function () {
            $(gridSelector).show();
        });

        $('#ApplyCompensationFalse').change(function () {
            $(gridSelector).hide();
        });
    }

    pregnancyLeave.InitPregnancyLeaveAbsenceGrid = function (subscriptionKey) {
        $("#pregnancyLeaveAbsenceGrid").DataTable(datatable.defaultDataTableOptions( {
            ajax: {
                url: `/PregnancyLeave/SearchAbsenceSettings?subscriptionKey=${subscriptionKey}`
            },
            columns: [
                { data: "startDate", name: "StartDate", title: "Van", orderable: true, searchable: false },
                { data: "endDate", name: "EndDate", title: "t/m", orderable: true, searchable: false },
                { data: "description", name: "Description", title: "Toelichting", orderable: true, searchable: false },
                { data: "region", name: "Region", title: "Vakantieregio", enum: enums.region, orderable: true, searchable: false },
                { responsivePriority: -1, defaultContent: "", orderable: false, searchable: false }
            ],
            order: [[0, 'desc']],
            columnDefs: [
                {
                    targets: [0, 1],
                    render: function(data, type, full, meta) {
                        return datatable.dutchDateFormat(data, "DD-MM-YYYY");
                    }
                },
                {
                    targets: -1,
                    className: 'text-end text-nowrap',
                    width: '75px',
                    fixed: true,
                    render: function (data, type, full, meta) {
                        return `<a data-bs-toggle="modal" data-bs-target="#modalcontainer" class="btn btn-outline-primary fas fa-trash-alt" title="Verwijderen" href="/PregnancyLeave/DeleteAbsenceSetting?key=${full.key}&subscriptionKey=${subscriptionKey}"></a>`;
                    }
                }
            ]
        }));
    }

}(window.pregnancyLeave = window.pregnancyLeave || {}, $));
